import { render, staticRenderFns } from "./EdLinkRedirectView.vue?vue&type=template&id=36cf4490&scoped=true&"
import script from "./EdLinkRedirectView.vue?vue&type=script&lang=js&"
export * from "./EdLinkRedirectView.vue?vue&type=script&lang=js&"
import style0 from "./EdLinkRedirectView.vue?vue&type=style&index=0&id=36cf4490&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf4490",
  null
  
)

export default component.exports